import React from 'react';

import FlyoutToggleButton from 'brandComponents/flyouts/FlyoutToggleButton';
import Icon from 'brandComponents/Icon';
import {useMinicartCount} from 'brandComponents/MinicartCount';

const MinicartServiceMenuItem = () => {
	// Optimistic: includes the products of the adds still running.
	const {count} = useMinicartCount();

	const buttonContent = (
		<div className="basket-totals">
			<Icon
				name="bag"
				height={20}
				width={20}
			/>
			{count > 0 && (
				<div className="basket-totals-items__count">
					<span>{count}</span>
				</div>
			)}
		</div>
	);

	return <FlyoutToggleButton buttonContent={buttonContent} flyoutId="minicart" />;
};

export default MinicartServiceMenuItem;
